import { get } from "lodash";
import log from "loglevel";
import * as t from "./types";

export const getAccountUsersReducerResponse = (
  state: any,
  responseType: string
): t.AccountUser[] => {
  log.info("Getting AccountUsers from Store...");
  const value = get(state, `accountUsers.response.${responseType}`);
  return value;
};
